import {
	getButtonLinkFromSelectedContent,
	getHasButtonLinkFromSelectedContent,
	getImagesFromSelectedContent,
	getItemContentVideoFromSelectedContent,
	getTextFromSelectedContent,
	getTitleFromSelectedContent,
} from 'store/programItems';

import { WithSequenceStatePropsType } from 'components/hoc/withSequenceState';
import withSequenceState from 'components/hoc/withSequenceState';
import CardDetailRecommendation from 'components/molecules/Card/Detail/Recommendation';
import { CardDetailPropsType } from 'components/molecules/Card/Fragments/CardDetail';
import Sequences from 'defs/sequences';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RootStateType } from 'store/programItems';
import { actionCreators } from 'store/programItems';

export type ButtonLinkType = ReturnType<typeof getButtonLinkFromSelectedContent>;
export type LinkListType = {
	modifier: string;
	links: Array<ButtonLinkType>;
};

export type StateToPropsType = {
	title: ReturnType<typeof getTitleFromSelectedContent>;
	isDone: boolean;
	contentVideo: ReturnType<typeof getItemContentVideoFromSelectedContent>;
	linkList?: LinkListType;
	images: ReturnType<typeof getImagesFromSelectedContent>;
	text: ReturnType<typeof getTextFromSelectedContent>;
};
export type DispatchToPropsType = typeof actionCreators;

const mapStateToProps = (state: RootStateType, ownProps: CardDetailPropsType): StateToPropsType => {
	const selectedContent = ownProps.parentProps as any;
	return {
		title: getTitleFromSelectedContent(selectedContent),
		isDone: false,

		contentVideo: getItemContentVideoFromSelectedContent(selectedContent),

		linkList: getHasButtonLinkFromSelectedContent(selectedContent)
			? { modifier: 'center', links: [getButtonLinkFromSelectedContent(selectedContent)] }
			: undefined,

		images: getImagesFromSelectedContent(selectedContent),

		text: getTextFromSelectedContent(selectedContent),
	};
};

const mapDispatchToProps = (dispatch): DispatchToPropsType => {
	return bindActionCreators(actionCreators, dispatch);
};

export type ContainerCardDetailRecommendationFavoritePropsType = CardDetailPropsType &
	StateToPropsType &
	DispatchToPropsType &
	WithSequenceStatePropsType;

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withSequenceState(CardDetailRecommendation, [Sequences.CARD_IS_CHECKING]) as any);
